export const apiEndpoint: string = process.env.API_ENDPOINT;
export const environment: string = process.env.ENVIRONMENT;
